/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import ItemImage from './ItemImage';
import styles from './styles.module.scss';

const getItems = (shipments) =>
  shipments.reduce((result, shipment) => {
    const productItems = shipment.products.reduce(
      (prodItems, product) => [...prodItems, ...product.items],
      [],
    );
    return [...result, ...productItems];
  }, []);

const MobileItems = ({ shipments }) => {
  const items = getItems(shipments);
  return (
    <ul className={styles['mobile-items']} data-testid="mobile-items">
      {items.map(({ name, brandName, imageUrl, autoAssigned, slug }, itemIndex) => (
        <ItemImage
          key={itemIndex}
          name={name}
          brandName={brandName}
          imageUrl={imageUrl}
          autoAssigned={autoAssigned}
          slug={slug}
        />
      ))}
    </ul>
  );
};

MobileItems.propTypes = {
  shipments: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default MobileItems;
